import React from 'react';
import { View, Text, StyleSheet } from '@react-pdf/renderer';
import { Entente } from '../../../../../../../common/src/entities';
import PriceTable from './PriceTablePDF';
import DetailsActiviteEntentePDF from './DetailsActiviteEntentePDF';
import HoraireEntentePDF from './HoraireEntentePDF';

// Visibilité Client
export default function EtatCompteContent({ entente }: { entente: Entente }) {
    const copieActiviteEntente = entente.activiteEntentes.filter(
        (activiteEntente) => activiteEntente.activite.typeActivite.name != 'Autobus',
    );

    const activiteEntenteBus = entente.activiteEntentes.filter(
        (activiteEntente) => activiteEntente.activite.typeActivite.name == 'Autobus',
    );

    const styles = StyleSheet.create({
        sectionTitle: {
            fontWeight: 'bold',
            fontSize: 9,
            marginTop: 5,
            marginBottom: 2,
        },
        bulletPoint: {
            flexDirection: 'row',
            alignItems: 'center',
        },
        bullet: {
            width: 10,
            textAlign: 'center',
        },
        bulletText: {
            flex: 1,
            fontSize: 8,
        },
    });

    const suiviStyles = StyleSheet.create({
        table: { width: '100%', margin: 2 },
        tableRow: { flexDirection: 'row', paddingBottom: 1 },
        tableHeader: { backgroundColor: 'black', color: 'white', padding: 1 },
        tableCell: { flex: 1, padding: 1, fontSize: 9 },
        totalRow: {
            fontWeight: 'bold',
            backgroundColor: 'black',
            color: 'white',
            padding: 1,
        },
    });

    return (
        <>
            <View wrap={false}>
                <Text style={{ textDecoration: 'underline', fontWeight: 'bold' }}>Facture #11111</Text>
                <Text style={{ fontSize: 11, paddingBottom: 1 }}>
                    Numéro de fournisseur: {copieActiviteEntente[0].activite.fournisseur.id}
                </Text>
            </View>

            <View style={suiviStyles.table}>
                <View style={[suiviStyles.tableRow, suiviStyles.tableHeader]}>
                    <Text style={[suiviStyles.tableCell, { fontWeight: 'bold', textAlign: 'center' }]}>
                        Suivi du compte
                    </Text>
                </View>
                <View
                    style={[suiviStyles.tableRow, suiviStyles.tableHeader, { padding: 0, backgroundColor: '#2b2b2b' }]}
                >
                    <Text style={[suiviStyles.tableCell]}>Date</Text>
                    <Text style={[suiviStyles.tableCell]}>Opération</Text>
                    <Text style={[suiviStyles.tableCell, { flex: 2 }]}>Montant</Text>
                </View>
                <View style={suiviStyles.tableRow}>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left' }]}>2016-04-18</Text>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left' }]}>Facture</Text>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left', flex: 2 }]}>(767.00) $</Text>
                </View>
                <View style={suiviStyles.tableRow}>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left' }]}>2016-05-05</Text>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left' }]}>chèque</Text>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left', flex: 2 }]}>383.50 $</Text>
                </View>
                <View style={suiviStyles.tableRow}>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left' }]}>2016-06-15</Text>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left' }]}>chèque</Text>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left', flex: 2 }]}>383.50 $</Text>
                </View>
                <View style={suiviStyles.tableRow}>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left' }]}></Text>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'right' }]}>Total :</Text>
                    <Text style={[suiviStyles.tableCell, { textAlign: 'left', flex: 2 }]}>111.00 $</Text>
                </View>
            </View>

            {copieActiviteEntente.map((activiteEntente) => (
                <View wrap={false}>
                    <DetailsActiviteEntentePDF
                        activiteEntente={activiteEntente}
                        entente={entente}
                        activiteEntenteBus={activiteEntenteBus}
                        type_visibilite={'client'}
                        afficherEtendueAge={false}
                        afficherTypeActivite={false}
                        afficherUrgence={false}
                        afficherTypeClient={false}
                        afficherLangue={false}
                        afficherLieu={false}
                        afficherAutresDetails={false}
                        afficherPolitiquesAutobus={false}
                        afficherFactureRelated={true}
                    />
                </View>
            ))}
            <View wrap={false}>
                <PriceTable entente={entente} isFacture={false} />
            </View>
            <View wrap={false}>
                <Text style={styles.sectionTitle}>Méthodes de paiement</Text>

                {[
                    'Faire le paiement au nom de 9379-8940 Québec inc. (Solution Animation)',
                    'Pour un paiement par la poste, l’envoyer à l’adresse apparaissant dans l’en-tête.',
                    'Pour un paiement par dépôt direct : au 30015 815 090 137 1 (compte en fidéicommis)\n-Transit de caisse: 30015 - N° d’institution: 815 - N° compte: 090 137 1\nUn paiement par dépôt direct doit être jumelé à un avis de paiement envoyé par courriel à isaacbarbe@solutionanimation.com (animation, date, école, montant, etc.).',
                    'En cas de retard de paiement un taux mensuel de 2% de pénalité s’applique (taux annuel de 24%).',
                    'Le délai de paiement est de 30 jours à partir de la date d’émission. Les pénalités peuvent être exigées dès le 31ième jour.',
                    'Le montant des pénalités est calculé à partir du prix hors taxes indiqué sur la facture.',
                    'Une indemnité forfaitaire pour frais de recouvrement de 25$ à chaque 61 jours à partir de la date d’émission de la facture.',
                    'Le montant des pénalités et les indemnités peuvent être facturés seuls sur une nouvelle facture ou sur une facture ultérieure du client.',
                ].map((item, index) => (
                    <View key={index} style={styles.bulletPoint}>
                        <Text style={styles.bullet}>{'\u2022'}</Text>
                        <Text style={styles.bulletText}>{item}</Text>
                    </View>
                ))}
            </View>

            <View wrap={false}>
                <Text style={styles.sectionTitle}>À savoir</Text>

                {[
                    'Si applicable, les services offerts par Solution Animation sont considérés comme des excursions touristiques de moins d’une journée.',
                    'Les excursions touristiques de moins d’une journée ne requièrent pas de permis d’agence de voyage ni de contribution au FICAV.',
                    '9379-8940 Québec inc. (Solution Animation) est détenteur d’un permis d’agent de voyages du Québec.',
                    '9379-8940 Québec inc. (Solution Animation) est détenteur d’un permis d’intermédiaire en transport 1-C-30808-1.',
                    'Les fonds sont déposés dans un compte en fidéicommis. (Applicable aux services d’agence de voyages seulement.)',
                ].map((item, index) => (
                    <View key={index} style={styles.bulletPoint}>
                        <Text style={styles.bullet}>{'\u2022'}</Text>
                        <Text style={styles.bulletText}>{item}</Text>
                    </View>
                ))}
            </View>
        </>
    );
}
